import Spacer from '@/common/components/spacer';

interface GasSaverMarketingTileDrawerDialogCopyProps {
  gasSaverCents: string;
}

export default function GasSaverMarketingTileDrawerDialogCopy({
  gasSaverCents,
}: GasSaverMarketingTileDrawerDialogCopyProps) {
  return (
    <>
      <p className="body-strong">Save {gasSaverCents}/gal on every fill-up at Sunoco</p>
      <Spacer variant="height4" />
      <p className="body">
        Go to any Sunoco in your area. Pay at the pump as usual. Our connected car system
        automatically credits your savings to the next monthly invoice — like magic!
      </p>
      <Spacer variant="height24" />
    </>
  );
}
